import React from 'react';
import cx from "classnames";
import PropTypes from "prop-types";
import "./tag.scss";

const Index = (props) => {
    const {children, className, color} = props;
    const classNames = cx(
        'd-tag',
        className,
        `d-tag--${color}`
    );

    return (
        <div className={classNames}>
            {children}
        </div>
    );
};

Index.propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf(["green","black","blue", "purple", "pink", "red", "orange","gray"])
};
Index.defaultProps = {
    className: '',
    color: 'black'
};
export default Index;
